<template>
  <div>
    <div class="lottery-bg com-news">
      <div class="txtMarquee-left">
        <div class="block">
          <div class="iconfont icon-tongzhi2"></div>
          <p>
            <font style="vertical-align: inherit"><font style="vertical-align: inherit">最新公告</font></font>
          </p>
          <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
            <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">★★★官方平台运营商服务商定期，请您对TG入账款概入账款我司查看最新入账！不负责付账！请给您的每次入账费用！请查看最新的银行入账款。 </font></font></marquee
            >
          </div>
        </div>
      </div>
    </div>
    <div id="lottery-content">
      <div class="wrapper1">
        <section id="lobby" class="ng-scope">
            <ul class="game-list" >
            <li :game-box="item.platform_name == 'ig' ? 'l-'+item.game_code : 'l-'+item.platform_name  "   v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1 " @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :title="item.name">
              <!-- <span style="color:#fff">{{item.name}} -- {{item.platform_name}} --{{item.game_code}}</span> -->
            </li>
       
          </ul>
      
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lottery',
  data() {
    return {
      gameList: [],

      imgList: {
        yb: { img: 'l-cpyb' },
        vrbet: { img: 'l-cpvr' },
        GFC: { img: 'cpiggfc' },
        LOTTO: { img: 'cpigssc' },
        LOTTERY: { img: 'cpigxgc'},
        gfc: { img: 'cpiggfc' },
        lotto: { img: 'cpigssc' },
        Llottery: { img: 'cpigxgc' },
        dl: { img: 'l-cpdl' },
        bbin: { img: 'l-cpjz' },
        tc: { img: 'l-cptcg' },
        imone: { img: 'l-cpjz' },
        obgcp: { img: 'l-cpjz' },
        jz: { img: 'l-cpjz' },
      },
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'lottery' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.$parent.hideLoading();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/lottery.vue